import { Injectable } from "@angular/core";

import { of, throwError } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { ToastrService } from "ngx-toastr";
import { TechSupportService } from "../services/tech-support.service";
import { clientConfig } from "../../shared/constant/app.constant"

@Injectable()
export class TechSupportResolver  {

    techSupportResult: any;
    constructor(
        private store: Store<AppState>,
        private techSupportService: TechSupportService
    ) { }
    resolve() {

        if (clientConfig.APPFLOW.includes("TechSupportFlow")) {
            this.store.pipe(select("techSupport")).subscribe((items) => {
                this.techSupportResult = items;
            });

            if (this.techSupportResult.items.length != 0) {
                let itemDetails = [];
                itemDetails = this.techSupportResult.items
                    .filter((item) => item.assessmentResult.toLowerCase().trim() === "customer service needed")
                    .map((item) => {
                        return {
                            itemNumber: item.itemNumber,
                            itemName: item.itemName,
                            assessmentId: item.assessmentId,
                            assessmentResult: item.assessmentResult,
                            itemQuantity: parseInt(item.itemQuantity)
                        }
                    });

                if (itemDetails.length !== 0) {
                    return this.techSupportService.bookCustomerService(itemDetails).pipe(
                        catchError((error) => {
                            console.log(error)
                            return of("Customer Service Request Failed");
                        })
                    );
                }

                return "No Items present for Customer Service"
            }
            return "No Items present for Tech Support"
        }
        return "Customer service not applicable for this flow";
    }

}